<template>
    <div>
        <mensajeSistema></mensajeSistema>

        <v-row>
            <v-col cols="12" sm="4" md="">
                <v-select label="Nivel:" v-model="filter.id_nivel" @change="eventNivel(filter.id_nivel)" :items="listNivel"
                    item-value="id" item-text="desc_nivel"></v-select>
            </v-col>

            <v-col cols="12" sm="4" md="">
                <v-select label="Periodo:" v-model="filter.id_periodo" :items="listPeriodo" item-value="id"
                    item-text="nombre_periodo"></v-select>
            </v-col>

            <v-col cols="12" sm="4" md="">
                <v-select label="Grado:" v-model="filter.id_grado" @change="eventGrado(filter.id_grado)" :items="listGrado"
                    item-value="id" item-text="desc_grado"></v-select>
            </v-col>

            <v-col cols="12" sm="4" md="">
                <v-select label="Sección:" v-model="filter.id_seccion" @change="eventSeccion(filter.id_seccion)"
                    :items="listSeccion" item-value="id" item-text="nombre_seccion"></v-select>
            </v-col>

            <!-- <v-col cols="12" sm="4" md="">
                <v-select label="Tutor" item-value="id" item-text="nombre_apellido"></v-select>
            </v-col>

            <v-col cols="12" sm="4" md="">
                <v-select label="Escala evaluativa" item-value="id" item-text="nombre_apellido"></v-select>
            </v-col> -->
        </v-row>
        <div>
            <!-- Modal de Observaciones -->
            <v-dialog v-model="mostrarModal" max-width="500px">
                <v-card>
                    <v-card-title>
                        Observaciones
                        <v-spacer></v-spacer>
                        <v-btn icon @click="mostrarModal = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-textarea v-model="observaciones" label="Observaciones" rows="3"></v-textarea>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="postObservaciones">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- AG-Grid Component -->
            <ag-grid-vue class="ag-theme-balham" style="width: 100%; height: 500px" :rowData="rowData"
                :columnDefs="todasLasColumnas" :gridOptions="gridOptions" @cell-clicked="onCellClicked"
                @cell-value-changed="onCellValueChanged" @grid-ready="onGridReady">
            </ag-grid-vue>
        </div>
    </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { AgGridVue } from "ag-grid-vue";

export default {
    name: "NotasConductuales",

    components: {
        AgGridVue,
    },
    data: () => ({
        rutaservidor: API_URL,
        datoLogin: sessionStorage,
        // consulta principal

        data: [],
        filter: {},
        listPeriodo: [],
        listAlumno: [],
        listNivel: [],
        listGrado: [],
        // configuracion para la grilla
        gridApi: null,
        gridOptions: {
            getRowNodeId: (data) => data.numdoc_persona,
        },
        //
        listSeccion: [],
        listTipoIncidencia: [],
        listCriteriosConducta: [],
        listPapeletas: [],
        incidenciaPapeleta: [],
        listFilter: {},
        columnDefs: [],
        rowData: [],
        columnDefsDinamicas: [],
        todasLasColumnas: [],
        asistenciaPorClaseMap: {},
        totalObservaciones: [],

        promedio: "",
        observaciones: "",
        datosDinamicos: [],
        isUpdating: false, // estado para saber si se esta editando las filas
        //variables para el modal de observaciones
        mostrarModal: false,
        idAlumno: null,
        nombre_apellido: "",
        numdoc_persona: "",
        papeletas: [],
        listObservaciones: [],
    }),

    // computadas.

    computed: {
        ...mapGetters("login", ["componenteEvento"]),
        columnDefsStatic() {
            return [
                {
                    headerName: "N° Documento",
                    field: "numdoc_persona",
                    pinned: "left",
                    width: 100,
                    minWidth: 50,
                },
                {
                    headerName: "Nombre y apellido",
                    field: "nombre_apellido",
                    pinned: "left",
                    width: 120,
                    minWidth: 200,
                },
                {
                    headerName: "prom",
                    field: "promedio_general",
                    pinned: "left",
                    width: 70,
                    minWidth: 20,
                    cellStyle: this.celdaRoja,
                },
                {
                    headerName: "Observaciones",
                    cellRenderer: this.iconCellRenderer,
                    pinned: "left",
                    width: 100,
                    minWidth: 20,
                },
            ];
        },
    },

    mounted() {
        this.loadMain();
        this.getConfiguracion();
    },

    methods: {
        // -- Validar accesos por perfil ------------
        ...mapActions("login", ["parametroComponente"]),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente);
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations("mensajeSis", ["setEnviarMens"]),
        ////////////////////////////////////////////////////////

        async loadMain() {
            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_nivel: "",
                id_periodo: "",
                id_grado: "",
                id_seccion: "",
            };
            this.getNivel(this.datoLogin.id_ano_lectivo);
           // this.getTotalObservaciones();
        },

        // propiedad de la grilla para actualizar las observaciones 
        onGridReady(params) {
            this.gridApi = params.api; // Obtiene la referencia de gridApi
        },

        async getPeriodo(id_colegio, id_ano_lectivo, id_nivel) {
            let params = { id_colegio, id_ano_lectivo, id_nivel };
            try {
                let response = await axios.post(`/sistema/integral/getPeriodo/`, {
                    filter: params,
                });
                this.listPeriodo = response.data;
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },
        // esta es la funcion que renderiza el icono de las observaciones
        iconCellRenderer(params) {
           
            const alumnoId = params.node.data.id_alumno;
            const observaciones = this.totalObservaciones.find(
                (obs) => obs.id_alumno === alumnoId
            );
            const iconColor =
                observaciones && observaciones.observaciones
                    ? "#0ABEC7"
                    : "rgb(175, 164, 164)";

            return `<i class="fas fa-comment" data-id="${params.node.data.id_alumno}" 
                    style="color: ${iconColor}; font-size: 24px; display: flex; align-items: center; justify-content: center;"></i>`;
        },

        // este es el metodo que renderiza el contenido del modal de observaciones
        onCellClicked(event) {
            this.observaciones = "";
            if (event.event.target.classList.contains("fa-comment")) {
                this.idAlumno = event.event.target.getAttribute("data-id");
                this.nombre_apellido = event.data.nombre_apellido;
                this.numdoc_persona = event.data.numdoc_persona;
                this.mostrarModal = true;
            }

            this.getObservaciones();
        },

        // aca asigno las filas es decir el contenido.
        async getAsistenciaClase() {
            try {
                let response = await axios.post(
                    "/evaluacion/notasconductuales",
                    this.filter
                );

                //Mapear asistenciaPorClase para crear una estructura de datos inicial.
                this.asistenciaPorClaseMap = response.data.asistenciaPorClase.reduce(
                    (acc, alumno) => {
                        acc[alumno.id_alumno] = {
                            nombre_apellido: alumno.nombre_apellido,
                            numdoc_persona: alumno.numdoc_persona,
                            id_alumno: alumno.id_alumno,
                            Presente2: alumno.presente,
                            Tardanza_justificada2: alumno.tardanza_justificada,
                            Tardanza_injustificada2: alumno.tardanza_injustificada,
                            Falta_justificada2: alumno.falta_justificada,
                            Falta_injustificada2: alumno.falta_injustificada,
                        };
                        return acc;
                    },
                    {}
                );

                // Agregar datos de asistenciaGeneral al map existente.
                response.data.asistenciaGeneral.forEach((alumno) => {
                    if (this.asistenciaPorClaseMap[alumno.id_alumno]) {
                        this.asistenciaPorClaseMap[alumno.id_alumno].Presente =
                            alumno.total_presente;
                        this.asistenciaPorClaseMap[alumno.id_alumno].Tardanza_justificada =
                            alumno.total_tardanza_justificada;
                        this.asistenciaPorClaseMap[alumno.id_alumno].Tardanza_injustificada =
                            alumno.total_tardanza_injustificada;
                        this.asistenciaPorClaseMap[alumno.id_alumno].Falta_justificada =
                            alumno.total_falta_justificada;
                        this.asistenciaPorClaseMap[alumno.id_alumno].Falta_injustificada =
                            alumno.total_falta_injustificada;
                        this.asistenciaPorClaseMap[alumno.id_alumno].id_tipo_incidencia =
                            alumno.id_tipo_incidencia;
                    }
                });

                this.datosDinamicos = response.data.notasconductuales;
                this.datosDinamicos.forEach((datoDinamico) => {
                    const alumnoId = datoDinamico.id_alumno;

                    if (this.asistenciaPorClaseMap[alumnoId]) {
                        const criterio = datoDinamico.criterio
                            .toLowerCase()
                            .replace(/ /g, "_");
                        this.asistenciaPorClaseMap[alumnoId][criterio] =
                            datoDinamico.calificacion;
                        this.asistenciaPorClaseMap[alumnoId]["Prom"] =
                            datoDinamico.escala_evaluativa;
                        // this.asistenciaPorClaseMap[alumnoId]['observaciones'] = null;
                        this.asistenciaPorClaseMap[alumnoId]["promedio"] =
                            datoDinamico.prom;
                        this.asistenciaPorClaseMap[alumnoId]["promedio_general"] =
                            datoDinamico.prom;
                    }
                });

                this.papeletas = response.data.papeletas;
                this.papeletas.forEach((papeleta) => {
                    const alumnoId = papeleta.id_alumno;
                    if (this.asistenciaPorClaseMap[alumnoId]) {
                        const papeletaBack = papeleta.tipo_papeleta
                            .toLowerCase()
                            .replace(/ /g, "_");
                        this.asistenciaPorClaseMap[alumnoId][papeletaBack] =
                            papeleta.puntaje_total;
                    }
                });

                this.rowData = Object.values(this.asistenciaPorClaseMap);
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        async getNivel(id_ano_lectivo) {
            let params = { id_ano_lectivo, id_colegio: sessionStorage.id_colegio };
            try {
                let response = await axios.post(`/sistema/integral/getNivelAdm/`, {
                    filter: params,
                });
                this.listNivel = response.data;
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        async getGrado(id_colegio, id_nivel) {
            let params = { id_colegio, id_nivel };
            try {
                let response = await axios.post(`/sistema/integral/getGradoAdm/`, {
                    filter: params,
                });
                this.listGrado = response.data;
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        async getSeccion(id_colegio, id_grado) {
            let params = { id_colegio, id_grado };
            try {
                let response = await axios.post(`/sistema/integral/getSeccionAdm/`, {
                    filter: params,
                });
                this.listSeccion = response.data;
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        eventNivel(id_nivel) {
            this.listGrado = [];
            this.filter.id_grado = "";
            this.listSeccion = [];
            this.filter.id_seccion = "";
            this.listAlumno = [];
            this.filter.id_alumno = "";
            this.listFilter = {
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_colegio: this.datoLogin.id_colegio,
                id_nivel,
            };
            this.getPeriodo(
                this.datoLogin.id_colegio,
                this.datoLogin.id_ano_lectivo,
                id_nivel
            );
            this.getGrado(this.datoLogin.id_colegio, id_nivel);
            this.getAlumno();
        },

        eventPeriodo(id_periodo) {
            console.log(`Periodo: ${id_periodo}`);
        },

        eventGrado(id_grado) {
            this.listSeccion = [];
            this.filter.id_seccion = "";
            this.listAlumno = [];
            this.filter.id_alumno = "";
            this.getAlumno(
                this.datoLogin.id_colegio,
                this.datoLogin.id_ano_lectivo
            );
            this.getSeccion(this.datoLogin.id_colegio, id_grado);
            this.listFilter = {
                ...this.listFilter,
                id_grado: id_grado,
            };
        },

        eventSeccion(id_seccion) {
            this.listAlumno = [];
            this.filter.id_alumno = "";
            this.getRegistroConductual();
            this.getAlumno(
                this.datoLogin.id_colegio,
                this.datoLogin.id_ano_lectivo,
                id_seccion
            );
            this.listFilter = {
                ...this.listFilter,
                id_seccion: id_seccion,
            };
            this.getAsistenciaClase();
        },

        // peticion para solicitar a los alumnos
        async getAlumno(id_colegio, id_ano_lectivo, id_seccion) {
            let params = { id_colegio, id_ano_lectivo, id_seccion };

            try {
                let response = await axios.post(`/sistema/integral/getAlumnoSeccion/`, {
                    filter: params,
                });
                this.listAlumno = response.data;
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        // metodo para solicitar los criterios de conductas y columnas dinamicas .

        async getRegistroConductual() {
            try {
                this.columnDefsDinamicas = [];
                const response = await axios.post(
                    `/administrativo/manualidades/criterios/`,
                    {
                        id_ano_lectivo: this.filter.id_ano_lectivo,
                        id_periodo: this.filter.id_periodo,
                        id_nivel: this.filter.id_nivel,
                    }
                );
                this.listCriteriosConducta = response.data;

                const encabezadoConducta = {
                    headerName: "Conducta",
                    children: [],
                };

                this.listCriteriosConducta.forEach((elemento) => {
                    const columnaDinamica = {
                        headerName: elemento.nombre,
                        id: elemento.id,
                        field: elemento.nombre.toLowerCase().replace(/ /g, "_"),
                        cellStyle: this.celdaRoja,
                        editable: true,
                        width: 120,
                        minWidth: 20,
                    };
                    encabezadoConducta.children.push(columnaDinamica);
                });

                encabezadoConducta.children.push({
                    field: "Prom",
                    width: 70,
                    minWidth: 20,
                    cellStyle: this.celdaRoja,
                });

                this.columnDefsDinamicas.push(encabezadoConducta);

                const columnaProm = [
                    {
                        headerName: "Prom",
                        field: "promedio",
                        width: 70,
                        minWidth: 20,
                        cellStyle: this.celdaRoja,
                    },
                ];

                this.todasLasColumnas = [
                    ...this.columnDefsStatic,
                    ...this.columnDefsDinamicas,
                    ...columnaProm,
                ];

                let response2 = await axios.post(
                    `/administrativo/manualidades/papeletas/`,
                    {
                        id_ano_lectivo: this.filter.id_ano_lectivo,
                        id_tipo_incidencia: "0",
                    }
                );
                this.listPapeletas = response2.data;
                const encabezadoPapeleta = {
                    headerName: "Papeleta",
                    children: [],
                };

                this.listPapeletas.forEach((elemento) => {
                    const columnaDinamica = {
                        headerName: elemento.tipo_papeleta,
                        field: elemento.tipo_papeleta.toLowerCase().replace(/ /g, "_"),
                        width: 120,
                        minWidth: 20,
                        cellStyle: function () {
                            const baseStyle = {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            };

                            if (elemento.tipo_incidencia.id == 1) {
                                return { ...baseStyle, color: "blue" };
                            } else {
                                return { ...baseStyle, color: "red" };
                            }
                        },
                    };

                    encabezadoPapeleta.children.push(columnaDinamica);
                });

                const asistenciaColegio = {
                    headerName: "Asistencia al colegio",
                    children: [
                        { field: "Presente" },
                        { field: "Tardanza_justificada" },
                        { field: "Tardanza_injustificada" },
                        { field: "Falta_justificada" },
                        { field: "Falta_injustificada" },
                    ],
                };

                const asistenciaAClase = {
                    headerName: "Asistencia a clase",
                    children: [
                        { field: "Presente2" },
                        { field: "Tardanza_justificada2" },
                        { field: "Tardanza_injustificada2" },
                        { field: "Falta_justificada2" },
                        { field: "Falta_injustificada2" },
                    ],
                };

                this.todasLasColumnas = [
                    ...this.columnDefsStatic,
                    ...this.columnDefsDinamicas,
                    ...columnaProm,
                    encabezadoPapeleta,
                    asistenciaColegio,
                    asistenciaAClase,
                ];

                this.getAsistenciaClase();
            } catch (e) {
                console.log("Error al cargar la data inical", e);
            }
        },

        // metodo para guardar las observaciones.

        async postObservaciones() {
            const params = {
                id_colegio: this.filter.id_colegio,
                id_ano_lectivo: this.filter.id_ano_lectivo,
                id_nivel: this.filter.id_nivel,
                id_periodo: this.filter.id_periodo,
                id_seccion: this.filter.id_seccion,
                id_grado: this.filter.id_grado,
                id_alumno: this.idAlumno,
                num_documento: this.numdoc_persona,
                nombre_apellido: this.nombre_apellido,
                observaciones: this.observaciones,
            };

            try {
                let response = await axios.post(
                    "/evaluacion/notasconductuales/observaciones",
                    params
                );
                this.listObservaciones = response.data;
                await this.actualizarTotalObservaciones();
                this.mostrarModal = false;
                this.getObservaciones();
            } catch (error) {
                console.log(error);
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }
        },

        async actualizarTotalObservaciones() {
            // Llamar a la función que obtiene las observaciones actualizadas
            const newTotalObservaciones =
                await this.obtenerTotalObservacionesActualizadas();

            // Actualizar totalObservaciones con las observaciones actualizadas
            this.totalObservaciones = newTotalObservaciones;

            if (this.gridApi) {
                // gridApi está definido, puedes llamar a refreshCells
                this.gridApi.refreshCells();
            } else {
                console.error("gridApi is not defined yet.");
            }
        },

        async obtenerTotalObservacionesActualizadas() {
            // Realizar una solicitud para obtener las observaciones actualizadas
            const response = await axios.get(
                `/evaluacion/notasconductuales/observaciones/modalobservaciones/${this.filter.id_colegio}`
            );
            return response.data;
        },

        actualizarObservaciones() {
            // Actualiza las celdas que muestran el icono de observaciones
            const gridApi = this.gridOptions.api;
            gridApi.refreshCells({ force: true });
        },

        // metodo para controlar los cambios en las celdas

        onCellValueChanged(event) {
            if (this.isUpdating) {
                console.log("Actualización ya en curso...");
                return;
            }

            console.log("rrr", event);
            let newValue = event.newValue || "";
            const field = event.colDef.field || event.colDef.id;
            const rowData = event.data;

            // Convertir el valor a mayúsculas para la validación
            const valorEnMayusculas = newValue.toUpperCase();
            const esNumero = !isNaN(valorEnMayusculas);
            const esLetraValida = this.sonLetrasValidas(valorEnMayusculas);

            if (esNumero || esLetraValida) {
                if (esLetraValida) {
                    newValue = valorEnMayusculas;
                    event.node.setDataValue(field, newValue);
                }

                this.isUpdating = true;
                this.updateCellValueOnBackend(rowData, field, newValue)
                    .then(() => {
                        this.isUpdating = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.isUpdating = false;
                    });
                this.getAsistenciaClase();
            } else {
                this.revertirValor(event);
            }
        },

        sonLetrasValidas(valor) {
            // Solo Permite 'A', 'B', 'C' como un solo dígito y 'AD' como dos dígitos :)
            if (valor.length === 2) {
                return valor === "AD";
            } else if (valor.length === 1) {
                return ["A", "B", "C"].includes(valor);
            }
            return false;
        },

        // funcion que revierte los datos en caso de que el usuario coloque datos invalidos
        revertirValor(event) {
            event.node.setDataValue(event.colDef.field, event.oldValue);
        },

        // funcion que actualiza los datos al backend
        async updateCellValueOnBackend(rowData, field, newValue) {
            try {
                const payload = {
                    id_colegio: this.filter.id_colegio,
                    id_ano_lectivo: this.filter.id_ano_lectivo,
                    id_nivel: this.filter.id_nivel,
                    id_periodo: this.filter.id_periodo,
                    id_seccion: this.filter.id_seccion,
                    id_grado: this.filter.id_grado,
                    id_alumno: rowData.id_alumno || this.idAlumno,
                    prom: this.promedio,
                    num_documento: rowData.numdoc_persona || this.numdoc_persona,
                    nombre_apellido: rowData.nombre_apellido || this.nombre_apellido,
                    criterio: field || "-",
                    calificacion: newValue,
                    observaciones: this.observaciones,
                };

                    await axios.post(
                    "/evaluacion/notasconductuales/notaconductual",
                    payload
                );
                this.observaciones = "";
                this.getAsistenciaClase();
                this.mostrarModal = false;
            } catch (error) {
                console.log(error);
            }
        },

        async getObservaciones() {
            try {
                const response = await axios.get(
                    `/evaluacion/notasconductuales/observaciones/${this.filter.id_colegio}/${this.idAlumno}`
                );

                if (response.data.length > 0) {
                    this.observaciones = response.data[0].observaciones;
                   
                } else {
                    this.observaciones = [];
                }
            } catch (error) {
                console.error(error);
            }
        },

        async getTotalObservaciones() {
            const paramsObservaciones = this.datoLogin.id_colegio;
            console.log(paramsObservaciones);

            try {
                const response = await axios.get(
                    `/evaluacion/notasconductuales/observaciones/modalobservaciones/${this.filter.id_colegio}`
                );
                this.totalObservaciones = response.data;
                console.log("TotalObservaciones", this.totalObservaciones);
                this.actualizarObservaciones();
                
            } catch (error) {
                console.error("Error al obtener el total de observaciones:", error);
            }
        },

        celdaRoja(params) {
            if (params.value === "C") {
                return { color: "red" };
            }
            return { color: "blue" }; // Retorna null para no aplicar estilos especiales a otras celdas
        },

        async getConfiguracion() {

            try {
                let response = await axios.get(`/evaluacion/notasconductuales/configuracion/173` )
                console.log("configuracion",response.data);

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
    },
};
</script>
<style scoped>
.blue-icon {
    color: #dfe8e9;
}

.gray-icon {
    color: rgb(175, 164, 164);
}
</style>
